import React from 'react';
import PropTypes from 'prop-types';
import MenuElement from './MenuElement';
import { checkGlobalService } from '../utils/commons';

const MainMenu = ({
  menuConfig,
  servicesConfig,
  lang,
  preventDefaultLinks,
  expandSidebar,
  companyId,
  isEmBlue,
}) => {
  const hasToShowService = (menu, service, companyId) => {
    const isApiMandatoryCheck = (menu, service) => {
      return (
        !menu.apiIsMandatory ||
        (menu.apiIsMandatory && service.properties && service.properties.apiAccessEnabled == '1')
      );
    };

    const hasRolForService = (menu, service) => {
      return !menu.hasRol || (menu.hasRol && menu.hasRol.split(',').includes(service.rolId));
    };

    const hasCompanyIdInService = (service, companyId) => {
      return (
        service &&
        companyId &&
        service.properties &&
        service.properties.companies &&
        service.properties.companies.filter(company => {
          return company && company.id && company.id == companyId;
        }).length > 0
      );
    };
    return (
      service &&
      (checkGlobalService(service) ||
        (service.enable &&
          isApiMandatoryCheck(menu, service) &&
          hasRolForService(menu, service) &&
          hasCompanyIdInService(service, companyId)))
    );
  };

  const isActive = service => service && service.enable;

  const menuBlocks = menuConfig
    .map(menuBlock => {
      const serviceToShow = servicesConfig.find(service => service.service === menuBlock.service);
      menuBlock.hasToShow = hasToShowService(menuBlock, serviceToShow, companyId);
      menuBlock.isActive = isActive(serviceToShow);
      menuBlock.serviceItem = serviceToShow;
      return menuBlock;
    })
    .filter(service => {
      return service.hasToShow;
    })
    .sort((a, b) => b.isActive - a.isActive);

  return (
    <ul className="md__menu__accordion">
      {menuBlocks.map(menuBlock => (
        <MenuElement
          key={menuBlock.service}
          menuBlock={menuBlock}
          lang={lang}
          preventDefaultLinks={preventDefaultLinks}
          expandSidebar={expandSidebar}
          companyId={companyId}
          isEmBlue={isEmBlue}
        />
      ))}
    </ul>
  );
};

MainMenu.propTypes = {
  menuConfig: PropTypes.arrayOf(PropTypes.object).isRequired,
  servicesConfig: PropTypes.array.isRequired,
  lang: PropTypes.string.isRequired,
  preventDefaultLinks: PropTypes.bool,
  expandSidebar: PropTypes.func,
  companyId: PropTypes.string,
  isEmBlue: PropTypes.bool,
};

export default MainMenu;
